module.exports = __webpack_public_path__ + "static/media/rule.04889ed2.svg";